import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import Image from 'ui/Image';

const Footer = ({isOneApp, curriculumCdcId}) => {
    const {t} = useTranslation();

    return (
        <div className="Footer">
            <div className="Footer-container">
                <Image
                    src={
                        isOneApp
                            ? 'https://assets.livongo.com/image/upload/v1671042237/remonj/teladoc-health-logo_klawyq.png'
                            : 'https://assets.livongo.com/image/upload/v1671042382/remonj/livongo-logo_taza9n.png'
                    }
                    alt={t(
                        `footer.${isOneApp ? 'teladocLogo' : 'livongoLogo'}`
                    )}
                />
                <p>
                    &copy; {new Date().getFullYear()} {t('footer.copyright')}
                </p>
                {curriculumCdcId && <p>{curriculumCdcId}</p>}
            </div>
        </div>
    );
};

Footer.propTypes = {
    isOneApp: PropTypes.bool,
    curriculumCdcId: PropTypes.string,
};

export default Footer;
